const normaliseText = (value) => {
    if (typeof value !== 'string') {
        return null;
    }
    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : null;
};
const normaliseMessage = (value) => {
    const trimmed = normaliseText(value);
    if (!trimmed) {
        return null;
    }
    const lower = trimmed.toLowerCase();
    if (lower === 'true') {
        return null;
    }
    if (lower === 'false') {
        // Help the tester recover: the name they typed (or that prefilled
        // from their profile) doesn't match the SAGA register for that
        // number. Common cause is given-name vs preferred-name (e.g. SAGA
        // has "Rudolph" but profile has "Rudi").
        return 'SAGA number does not match the name and surname on your SAGA membership. Make sure the name spelling matches your SAGA card exactly.';
    }
    return trimmed;
};
const isActivityStatus = (candidate, keyword) => {
    if (!candidate) {
        return false;
    }
    return candidate.toLowerCase().includes(keyword);
};
export const interpretSagaValidationResponse = (response) => {
    const handicap = normaliseText(response.handicap);
    const clubName = normaliseText(response.sagaclubname);
    const nameMismatch = normaliseMessage(response.namematch);
    const surnameMismatch = normaliseMessage(response.surnamematch);
    const mismatchMessages = [nameMismatch, surnameMismatch].filter((message) => Boolean(message));
    const activity = normaliseText(response.activitystatus);
    if (activity && activity.toLowerCase() === 'active' && mismatchMessages.length === 0) {
        return {
            status: 'valid',
            message: null,
            handicap,
            clubName,
            response,
        };
    }
    if (mismatchMessages.length > 0) {
        return {
            status: 'name-mismatch',
            message: mismatchMessages.join(' '),
            handicap,
            clubName,
            response,
        };
    }
    if (isActivityStatus(activity, 'does not exist')) {
        return {
            status: 'not-found',
            message: activity ?? 'Player does not exist.',
            handicap,
            clubName,
            response,
        };
    }
    if (isActivityStatus(activity, 'inactive')) {
        return {
            status: 'inactive',
            message: activity ?? 'Player is inactive.',
            handicap,
            clubName,
            response,
        };
    }
    return {
        status: 'unknown-error',
        message: activity ?? 'Unable to validate SAGA number.',
        handicap,
        clubName,
        response,
    };
};
//# sourceMappingURL=saga-validation.js.map